import { render } from "./DiscordServerZuordnung.vue?vue&type=template&id=78a96538"
import script from "./DiscordServerZuordnung.vue?vue&type=script&lang=js"
export * from "./DiscordServerZuordnung.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__